import editIcon from '../../assets/edit.svg';
import deleteIcon from '../../assets/delete.svg';

import EditButton from '../../components/buttons/EditButton';
import DeleteButton from '../../components/buttons/DeleteButton';

export default function ShoppingList({
  items,
  onToggle,
  onDelete,
  onEdit,
  onEditStore,
  onDeleteStore,
  editingItemId
}) {

  if (items.length === 0) {
    return (
      <p>No shopping items yet.</p>
    );
  }

  const activeItems = items.filter(
    item => !item.completed
  );
  const groupedItems = activeItems.reduce((groups, item) => {

    const store = item.store || 'Other';

    if (!groups[store]) {
      groups[store] = [];
    }

    groups[store].push(item);

    return groups;

  }, {});

  {/*RETURN CODE*/}
  return (

    <div style={{ marginTop: '20px' }}>

      {Object.entries(groupedItems).map(([store, storeItems]) => (

        <div key={store} style={{ marginBottom: '25px' }}>

          <div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }}
>

  <h3>{store}</h3>

  <div
    style={{
      display: 'flex',
      gap: '8px'
    }}
  >

    <EditButton
      onClick={() => onEditStore(store)}
    />

    <DeleteButton
      onClick={() => onDeleteStore(store)}
    />

  </div>

</div>

          {storeItems.map((item) => (

            <div
              key={item.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                borderBottom: '1px solid #ddd'
              }}
            >

              <input
                type="checkbox"
                checked={item.completed}
                onChange={() => onToggle(item)}
              />

              <div
                style={{
                  flex: 1,
                  textDecoration: item.completed
                    ? 'line-through'
                    : 'none',
                  opacity: item.completed
                    ? 0.5
                    : 1
                }}
              >
                {item.name}
              </div>

              <div>
                {item.quantity}
              </div>

              <div className="task-actions">

                <EditButton
                  onClick={() => onEdit(item)}
                />

                  <img src={editIcon} className="icon" alt="Edit" />

                

                <DeleteButton
                  onClick={() => onDelete(item.id)}
                />

              </div>

            </div>

          ))}

        </div>

      ))}

    </div>

  );
}